<template>
    <div v-if="show" class="EntityDetailsQuickActions">
        <h3 class="quick-actions-title">Schnellaktionen</h3>
        <div class="quick-actions-grid">
            <Button
                v-for="action in visibleActions"
                :key="action.key"
                variant="outline"
                size="small"
                @onClick="handleNavigate(action.page)"
            >
                <i :class="action.icon" style="margin-right: 4px"></i>
                <span>{{ action.label }}</span>
                <span class="button-hotkey">{{ action.hotkey }}</span>
            </Button>
        </div>
    </div>
</template>

<script>
import Button from '@/components/widgets/Button.vue';

const ACTION_CONFIGS = {
    driver: [
        {
            key: 'revenue',
            page: 'revenue',
            label: 'In Umsatz anzeigen',
            icon: 'ri-money-dollar-circle-line',
            hotkey: 'U',
            show: (isPlanBasic) => isPlanBasic,
        },
        {
            key: 'working-time',
            page: 'working-time',
            label: 'In Arbeitszeiten anzeigen',
            icon: 'ri-time-line',
            hotkey: 'A',
            show: (isPlanBasic) => isPlanBasic,
        },
        {
            key: 'shifts',
            page: 'shifts',
            label: 'In Schichten anzeigen',
            icon: 'ri-repeat-line',
            hotkey: 'S',
            show: () => true,
        },
        {
            key: 'trips',
            page: 'trips',
            label: 'In Einzelfahrten anzeigen',
            icon: 'ri-steering-2-line',
            hotkey: 'E',
            show: () => true,
        },
        {
            key: 'card-payments',
            page: 'card-payments',
            label: 'In Kartenzahlungen anzeigen',
            icon: 'ri-bank-card-line',
            hotkey: 'K',
            show: (isPlanBasic) => isPlanBasic,
        },
        {
            key: 'employees',
            page: 'employees',
            label: 'In Mitarbeiter anzeigen',
            icon: 'ri-team-line',
            hotkey: 'M',
            show: (isPlanBasic) => isPlanBasic,
        },
    ],
    car: [
        {
            key: 'revenue',
            page: 'revenue',
            label: 'In Umsatz anzeigen',
            icon: 'ri-money-dollar-circle-line',
            hotkey: 'U',
            show: (isPlanBasic) => isPlanBasic,
        },
        {
            key: 'shifts',
            page: 'shifts',
            label: 'In Schichten anzeigen',
            icon: 'ri-repeat-line',
            hotkey: 'S',
            show: () => true,
        },
        {
            key: 'trips',
            page: 'trips',
            label: 'In Einzelfahrten anzeigen',
            icon: 'ri-steering-2-line',
            hotkey: 'E',
            show: () => true,
        },
        {
            key: 'operationride',
            page: 'operationride',
            label: 'In Betriebsnachweis anzeigen',
            icon: 'ri-route-line',
            hotkey: 'B',
            show: (isPlanBasic) => isPlanBasic,
        },
        {
            key: 'cars',
            page: 'cars',
            label: 'In Fahrzeuge anzeigen',
            icon: 'ri-car-line',
            hotkey: 'F',
            show: (isPlanBasic) => isPlanBasic,
        },
    ],
    concession: [
        {
            key: 'trips',
            page: 'trips',
            label: 'In Einzelfahrten anzeigen',
            icon: 'ri-steering-2-line',
            hotkey: 'E',
            show: () => true,
        },
        {
            key: 'shifts',
            page: 'shifts',
            label: 'In Schichten anzeigen',
            icon: 'ri-repeat-line',
            hotkey: 'S',
            show: () => true,
        },
        {
            key: 'cars',
            page: 'cars',
            label: 'In Fahrzeuge anzeigen',
            icon: 'ri-car-line',
            hotkey: 'F',
            show: (isPlanBasic) => isPlanBasic,
        },
    ],
};

export default {
    name: 'EntityDetailsQuickActions',
    components: {
        Button,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        entityType: {
            type: String,
            default: 'driver',
        },
        isPlanBasic: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        visibleActions() {
            const actions = ACTION_CONFIGS[this.entityType] || [];
            return actions.filter((action) => action.show(this.isPlanBasic));
        },
    },
    methods: {
        handleNavigate(page) {
            this.$emit('navigate', page);
        },
    },
};
</script>

<style lang="scss" scoped>
.EntityDetailsQuickActions {
    margin-bottom: 24px;
    padding-top: 20px;
    border-top: 0.5px solid var(--color-border-light);

    .quick-actions-title {
        font-size: 14px;
        font-weight: 600;
        color: var(--color-text-black, #1a1a1a);
        margin: 0 0 12px 0;
    }

    .quick-actions-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 8px;
    }

    .Button {
        display: flex;
        align-items: center;
        gap: 8px;
        justify-content: flex-start;
        text-align: left;
        padding: 10px 12px;

        i {
            font-size: 16px;
            flex-shrink: 0;
        }

        span:not(.button-hotkey) {
            flex: 1;
        }

        .button-hotkey {
            font-weight: 600;
            color: var(--color-text-black, #1a1a1a);
            background: rgba(0, 0, 0, 0.05);
            padding: 2px 6px;
            border-radius: 3px;
            margin-left: auto;
            font-size: 11px;
            font-family: 'Courier New', monospace;
            flex-shrink: 0;
        }
    }
}
</style>
